package app

import kotlinx.browser.document
import org.jetbrains.compose.web.renderComposable
import org.w3c.dom.HTMLElement

fun main() {
    renderComposable(rootElementId = "root") {
        App()
    }
    // DOM is up immediately (no Skiko/Wasm), so drop the loading screen right away.
    (document.getElementById("loader") as? HTMLElement)?.className = "hide"
}
